export default __webpack_public_path__ + "static/media/filter.ec28c632.svg";